import useCallApi from '../../utilities/axios'
import { uploadTemp as uploadTempFileUrl, deleteTemp as deleteTempFileUrl } from './webServiceURL'

export interface FileUploaded {
    filename: string
    path: string
    fileToken: string
}

export interface DeleteTempFileRequest {
    fileToken: string[]
}

export default function useTempFileService() {
    const callApi = useCallApi()

    const uploadTempFile = async (params: FormData) => {
        const { data } = await callApi.axiosPost<{
            message: string
            status: number
            result: FileUploaded[]
        }>({ url: uploadTempFileUrl, params })
        return data
    }

    const deleteTempFile = async (params: DeleteTempFileRequest) => {
        const { data } = await callApi.axiosPost<{
            message: string
            status: number
            result: string
        }>({ url: deleteTempFileUrl, params })
        return data
    }

    return { uploadTempFile, deleteTempFile }
}
